import React from 'react';
import Skeleton from 'react-loading-skeleton';

/**Metric card which displays data in plain card*/
const MetricCard = ({
  svgsrc,
  icon,
  title,
  subTitle = '',
  titleClasses = '',
  headerClasses = '',
  subTitleClasses = '',
  metricValue,
  metricValueSuffix,
  loading,
  loaderHeight,
  btnText = '',
  metricClasses = '',
  svgClasses = '',
  btnAction = () => { },
  classes = '',
  alertText = '',
  alertClasses = '',
  /** Aayuv DS "Default card": label → optional description → large mono metric → caption (e.g. "X / Y employees") */
  variant = '',
  /** When variant is ds-default, set true to omit the top icon (matches minimal DS default stat card). */
  hideMetricIcon = false,
}) => {
  const hasMetricValue = metricValue !== undefined && metricValue !== null && metricValue !== '';
  const isDsDefault = variant === 'ds-default';
  const metricBlockClass =
    metricClasses ||
    (isDsDefault ? '' : 'flex items-center gap-2 mt-6 text-gray-900');

  if (loading) {
    return (
      <div className={classes.replace('flex', '')}>
        <Skeleton width='100%' height={loaderHeight} />
      </div>
    );
  }

  if (isDsDefault) {
    return (
      <div
        className={
          'flex h-full min-h-[178px] flex-col rounded-lg border border-gray-300 bg-white shadow-sm transition-all duration-200 ease-[cubic-bezier(.22,1,.36,1)] hover:-translate-y-0.5 hover:border-gray-400 hover:shadow-md ' +
          classes
        }
      >
        <div className={`flex min-h-0 flex-auto flex-col p-5 ${headerClasses}`}>
          <div className='flex items-start gap-3'>
            {!hideMetricIcon && (icon || svgsrc) && (
              <div className='shrink-0'>
                {icon || <img className={`h-8 w-8 ${svgClasses}`} src={svgsrc} alt='' />}
              </div>
            )}
            <div className='min-w-0 flex-1'>
              <div className={`text-sm font-semibold text-gray-900 ${titleClasses}`}>{title}</div>
              {subTitle ? (
                <p className={`mb-0 mt-1 text-xs leading-relaxed text-gray-600 ${subTitleClasses}`}>{subTitle}</p>
              ) : null}
            </div>
          </div>
          {hasMetricValue && (
            <div className='mt-5 flex flex-col items-start gap-2 text-gray-700'>
              <span className='font-jetbrains-mono text-3xl font-semibold tabular-nums text-gray-900'>
                {metricValue}
              </span>
              {metricValueSuffix != null && metricValueSuffix !== '' && (
                <span className='text-xs font-normal text-gray-700 font-sans'>{metricValueSuffix}</span>
              )}
            </div>
          )}
        </div>
        {btnText && (
          <div className={`border-t border-gray-200 bg-gray-50 px-6 py-4`}>
            <button
              type='button'
              className='cursor-pointer border-0 bg-transparent p-0 text-left text-xs font-semibold text-blue-600 hover:text-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 rounded-sm'
              onClick={btnAction}
            >
              {btnText}
            </button>
          </div>
        )}
        {alertText && (
          <div className={`flex items-center py-2 border-amber-100 bg-amber-50 ${alertClasses}`}>
            <p className='mb-0 text-xs text-amber-800'>{alertText}</p>
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className={
        'flex flex-col rounded-ds-md border border-gray-250 bg-white shadow-ds-sm transition-all duration-200 ease-[cubic-bezier(.22,1,.36,1)] hover:shadow-ds-md ' +
        classes
      }
    >
      <div className={`flex flex-auto flex-col justify-between p-5 ${headerClasses}`}>
        <div className='flex items-start gap-3'>
          <div className='shrink-0'>
            {icon || <img className={`inline-block h-7 ${svgClasses}`} src={svgsrc} alt='metric card avatar' />}
          </div>
          <div className='min-w-0 flex-1'>
            <span className={`block text-ts-md font-semibold leading-tight ${titleClasses ? titleClasses : 'text-gray-900'}`}>{title}</span>
            {subTitle && <span className={`mt-1 block text-xs leading-relaxed text-gray-600 ${subTitleClasses}`}>{subTitle}</span>}
          </div>
        </div>

        {hasMetricValue && (
          <div className={metricBlockClass}>
            <span className='font-jetbrains-mono tabular-nums'>{metricValue}</span>
            <span className='text-xs font-normal text-gray-600 font-sans'>
              {metricValueSuffix}
            </span>
          </div>
        )}
      </div>
      {btnText &&
        <div className={`border-t border-gray-200 bg-gray-50 px-5 py-4`}>
          <button
            type='button'
            className='cursor-pointer border-0 bg-transparent p-0 text-left text-xs font-semibold text-blue-600 hover:text-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 rounded-sm'
            onClick={btnAction}
          >
            {btnText}
          </button>
        </div>
      }
      {alertText && (
        <div className={`flex items-center py-2 border-amber-100 bg-amber-50 ${alertClasses}`}>
          <p className='text-xs mb-0 text-amber-800'>{alertText}</p>
        </div>
      )}
    </div>
  );
};

export default MetricCard;
